import styled from 'styled-components';
import { headerHeight } from 'theme/theme-helper-selectors';

export const Hexa = styled.div`
    position: absolute;
    z-index: 1;
    width: 100%;
    height: 1500px;
    top: -${headerHeight};
    right: 0;
    background-image: url(/assets/images/bussiness/hexa-green.png);
    background-size: cover;
    background-repeat: no-repeat;
`;
